const easeInOutQuad = (currentTime, start, change, duration) => {
  currentTime /= duration / 2;
  if (currentTime < 1) {
    return change / 2 * currentTime * currentTime + start;
  }
  currentTime--;
  return -change / 2 * (currentTime * (currentTime - 2) - 1) + start;
};
const scrollToItem = (elem, to, duration) => {
  const start = elem.scrollTop;
  const change = to - start;
  const startDate = +/* @__PURE__ */ new Date();
  const animateScroll = function() {
    const currentDate = +/* @__PURE__ */ new Date();
    const currentTime = currentDate - startDate;
    elem.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, duration));
    if (window && currentTime < duration) {
      window.requestAnimationFrame(animateScroll);
    } else {
      elem.scrollTop = to;
    }
  };
  animateScroll();
};
export {
  scrollToItem
};
//# sourceMappingURL=scroll-to-item.js.map
